import { VStack } from '../Layout/Stacks'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../ui/card'

type DivProps = React.ComponentProps<'div'>

interface ComponentProps extends DivProps {
  title: string
  description: React.ReactNode
  children: React.ReactNode
}

export const AuthCard: React.FC<ComponentProps> = ({
  title,
  children,
  description,
}) => {
  return (
    <VStack
      gap="6"
      className="w-full max-w-[600px] p-3"
      suppressHydrationWarning
    >
      <Card className="dark bg-card border-0 shadow-none rounded-2xl">
        <CardHeader className="text-center px-6 md:px-16 pt-10">
          <img
            src="/assets/images/logo-u.svg"
            alt="UNX"
            className="h-8 md:my-3"
          />
          <CardTitle className="text-4xl font-display">{title}</CardTitle>
          <CardDescription className="text-sm text-foreground text-center">
            <VStack gap="3">{description}</VStack>
          </CardDescription>
        </CardHeader>
        <CardContent className="px-6 md:px-16 pb-10">{children}</CardContent>
      </Card>
    </VStack>
  )
}

export default AuthCard
